<div class="container-fluid container-border">
  @if (lastSyncedDate) {
<div class="last-sync pull-right">
    <label class="last-sync">Last sync:</label>
    <label class="last-sync">{{ lastSyncedDate }}</label>
  </div>
}

  <div class="inner-container">
    <div class="buttons-row">
      <button class="btn btn-info" (click)="openHierarchyModel()" [disabled]="syncing">
        <i class="fa fa-plus-circle sync-icon"></i> Create New Hierarchy
      </button>
      <button class="btn btn-primary" (click)="assignModal()" [disabled]="!isPrivilegedSSO || syncing">
        <i class="fa fa-sitemap sync-icon"></i> Assign Business Hierarchy
      </button>
      <button class="btn btn-success" (click)="sync()" [disabled]="!isPrivilegedSSO || syncing">
        <i class="fa fa-refresh sync-icon" [class.fa-spin]="syncing"></i> Sync Business Hierarchy
      </button>
      <span class="search-wrapper">
        <input type="text" class="form-control search-input" [(ngModel)]="searchText" placeholder="search" />
        <i class="fa fa-search search-icon"></i>
      </span>
    </div>

    <div class="row toolbar">
      <div class="col-md-5 gold">
        <div class="toolbar-flex-row">
          <div class="hierarchy-type">
            <label>Application</label>
            <select class="form-control" [(ngModel)]="leftApp" (ngModelChange)="onAppChange('left')">
              <option value=""></option>
              @for (app of appsLeft; track $index) {
<option [value]="app.id">{{ app.label }}</option>
}
            </select>
          </div>
          <div class="hierarchy-type">
            <label>Hierarchy Type</label>
            <select class="form-control" [(ngModel)]="leftHierarchyId" (ngModelChange)="onHierarchyChange('left')">
              <option [ngValue]="null"></option>
              @for (h of hierarchiesLeft; track $index) {
<option [ngValue]="h.hierarchy_id">{{ h.hierarchy_name }}</option>
}
            </select>
          </div>
          <div class="tree-toolbar-icons">
            <i class="fa fa-folder toolbar-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Collapse All" direction="top" (click)="collapseAll('left')"></i>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-6 gtw">
        <div class="toolbar-flex-row">
          <div class="hierarchy-type">
            <label>Applications</label>
            <select class="form-control" [(ngModel)]="rightApp" (ngModelChange)="onAppChange('right')">
              <option value=""></option>
              @for (app of appsRight; track $index) {
<option [value]="app.id">{{ app.label }}</option>
}
            </select>
          </div>
          <div class="hierarchy-type">
            <label>Hierarchy Type</label>
            <select class="form-control" [(ngModel)]="rightHierarchyId" (ngModelChange)="onHierarchyChange('right')">
              <option [ngValue]="null"></option>
              @for (h of hierarchiesRight; track $index) {
<option [ngValue]="h.hierarchy_id">{{ h.hierarchy_name }}</option>
}
            </select>
          </div>
          <div class="tree-toolbar-icons">
            @if (treeLoading) {
<i class="fa fa-spinner fa-pulse" style="color: #e12827;"></i>
}
            @if (!treeLoading) {

              <i class="fa fa-file-excel-o toolbar-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Create Hierarchy (Excel)" direction="top" (click)="openHierarchyExcelModel()"></i>
              <i class="fa fa-plus toolbar-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Add Root BU" direction="top" (click)="openBusinessUnitModal()" [class.disabled-icon]="!rightHierarchyId"></i>
              <i class="fa fa-folder toolbar-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Collapse All" direction="top" (click)="collapseAll('right')"></i>
            
}
          </div>
        </div>
      </div>
    </div>

    <div class="row tree-container">
      <div class="left-tree col-md-5">
        <div class="col-border">
          @if (leftAlert) {
<div class="alert-message">{{ leftAlert }}</div>
}
          @if (leftNodes.length === 0 && !leftAlert) {
<div class="grey-background">No tree loaded.</div>
}
          @if (leftNodes.length > 0) {
<ul class="tree-list">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: leftNodes, side: 'left', depth: 1 }"></ng-container>
          </ul>
}
        </div>
      </div>
      <div class="col-md-1">
        <div class="col-border col-backcolor">
          <div class="show-diff-btn" (click)="compareHierarchies()">
            <i class="fa fa-cogs show-diff-icon"></i>
            <span class="show-diff-text">Show Difference</span>
          </div>
          @if (treeCompared) {
<div class="info-box">
            <div class="legend-item">
              <span class="legend-swatch legend-new-nodes"></span>
              <span>{{ onlyInTaxCount }} New Nodes Created</span>
            </div>
            <div class="legend-item">
              <span class="legend-swatch legend-gold-nodes"></span>
              <span>{{ onlyInGoldCount }} New Nodes In Gold</span>
            </div>
            <div class="legend-item">
              <span class="legend-swatch legend-edited"></span>
              <span>{{ editedCount }} Nodes Edited</span>
            </div>
            <div class="legend-item">
              <span class="legend-swatch legend-moved"></span>
              <span>{{ movedCount }} Nodes Moved</span>
            </div>
          </div>
}
        </div>
      </div>
      <div class="right-tree col-md-6">
        <div class="col-border" [class.drag-over-root]="dragOverRoot" (dragover)="onDragOverRoot($event)" (drop)="onDropRootByGesture($event)">
          @if (rightAlert) {
<div class="alert-message">{{ rightAlert }}</div>
}
          @if (dragMovingNode || movingNode) {
<div class="root-drop-hint">
            Drop here to move selected node as root
          </div>
}
          @if (rightNodes.length === 0 && !rightAlert) {
<div class="grey-background">No tree loaded.</div>
}
          @if (rightNodes.length > 0) {
<ul class="tree-list">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: rightNodes, side: 'right', depth: 1 }"></ng-container>
          </ul>
}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #nodeTemplate let-nodes let-side="side" let-depth="depth">
  @for (node of nodes; track $index) {
<li [class.level-1-node]="depth === 1">
    @if (isNodeVisible(node)) {
<span class="node-row">
      <span
        class="node-label"
        [class.moving-node]="side === 'right' && movingNode && movingNode.meKey === node.meKey"
        [class.drag-over-node]="side === 'right' && isDragOverNode(node)"
        [attr.draggable]="side === 'right' ? true : null"
        (dragstart)="side === 'right' ? onDragStartNode($event, node) : null"
        (dragover)="side === 'right' ? onDragOverNode($event, node) : null"
        (drop)="side === 'right' ? onDropByGesture($event, node) : null"
        (dragend)="side === 'right' ? onDragEndNode() : null">
        <i class="fa folder-icon"
           [ngClass]="{
             'fa-folder-open': node.children?.length && !node._collapsed,
             'fa-folder': !node.children?.length || node._collapsed,
             'folder-parent': depth === 1,
             'folder-child': depth > 1
           }"
           (click)="toggleNode(node); $event.stopPropagation()"></i>
        <strong>{{ node.meName }}</strong> @if (node.meCode) {
<span class="node-code">({{ node.meCode }})</span>
}
      </span>
      @if (side === 'right') {
<span class="node-actions" style="visibility: visible;">
        <i class="fa fa-plus action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Add Child BU" direction="top" (click)="openAddChildBusinessUnitModal(node)"></i>
        <i class="fa fa-edit action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit BU" direction="top" (click)="openEditBusinessUnitModal(node)"></i>
        <i class="fa fa-trash-o action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Delete BU" direction="top" (click)="deleteBusinessUnit(node)"></i>
        <i class="fa fa-angle-double-up action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Move BU To Root" direction="top" (click)="moveBusinessUnitToRoot(node)"></i>
        @if (!movingNode) {
<i class="fa fa-share action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select BU To Move" direction="top" (click)="startMoveNode(node)"></i>
}
        @if (movingNode && canDropOnNode(node)) {
<i class="glyphicon glyphicon-inbox action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Drop Selected BU Here" direction="top" (click)="dropMoveNode(node)"></i>
}
        @if (movingNode) {
<i class="glyphicon glyphicon-open action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Drop Selected BU As Root" direction="top" (click)="dropMoveNodeToRoot()"></i>
}
        @if (movingNode) {
<i class="fa fa-remove action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Cancel Move" direction="top" (click)="cancelMoveNode()"></i>
}
      </span>
}
      @if (side === 'left' && rightHierarchyId) {
<span class="node-actions" style="visibility: visible;">
        <i class="fa fa-angle-double-right action-icon" ap-tooltip [appendAfterTarget]="true" tooltipContent="Auto Push BU" direction="top" (click)="autoPushNode(node)"></i>
      </span>
}
    </span>
}
    @if (node.children?.length && !node._collapsed) {
<ul class="tree-list">
      <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node.children, side: side, depth: depth + 1 }"></ng-container>
    </ul>
}
  </li>
}
</ng-template>

<!-- ======================================================================= -->
<!-- Assign Business Hierarchy Modal                                         -->
<!-- ======================================================================= -->
@if (showAssignHierarchyModal) {
<div class="modal-overlay">
  <div class="modal-dialog-content admin-modal">
    <div class="modal-header">
      <h3 class="modal-title">Assign Business Hierarchy</h3>
      <div class="header-actions">
        <i (click)="closeAssignModal()" class="fa fa-times"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Tax Year</label>
        <select class="form-control" [(ngModel)]="assignTaxYear" (ngModelChange)="onAssignTaxYearChange()">
          <option value=""></option>
          @for (ty of taxYearOptions; track $index) {
<option [value]="ty.value">{{ ty.text }}</option>
}
        </select>
      </div>
      <div class="form-group">
        <label>Scenario</label>
        <select class="form-control" [(ngModel)]="assignScenario" (ngModelChange)="onAssignApplicationChange()">
          <option [ngValue]="null"></option>
          @for (s of assignScenarios; track $index) {
<option [ngValue]="s.scenario ?? s.value ?? s">{{ s.scenario_desc || s.label || s.scenario || s }}</option>
}
        </select>
      </div>
      <div class="form-group">
        <label>Application</label>
        <select class="form-control" [(ngModel)]="assignJcdKey" (ngModelChange)="onAssignApplicationChange()">
          <option [ngValue]="null"></option>
          @for (j of assignJcds; track $index) {
<option [ngValue]="j.jcd_key">{{ j.label || j.channel_name || j.name || j.jcd_key }}</option>
}
        </select>
      </div>
      <div class="form-group">
        <label>Default Hierarchy</label>
        <div class="form-control readonly">{{ assignDefaultHierarchyName }}</div>
      </div>
      <div class="form-group">
        <label>New Hierarchy</label>
        <select class="form-control" [(ngModel)]="assignNewHierarchyId">
          <option [ngValue]="null"></option>
          @for (h of assignHierarchies; track $index) {
<option [ngValue]="h.hierarchy_id">{{ h.hierarchy_name }}</option>
}
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-warning" (click)="closeAssignModal()">Cancel</button>
      <button class="btn btn-primary" (click)="submitAssignHierarchy()" [disabled]="assignLoading">
        Assign @if (assignLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
    </div>
  </div>
</div>
}

<!-- ======================================================================= -->
<!-- Create Hierarchy Modal                                                  -->
<!-- ======================================================================= -->
@if (showCreateHierarchyModal) {
<div class="modal-overlay">
  <div class="modal-dialog-content create-hierarchy-modal admin-modal">
    <div class="modal-header">
      <h3 class="modal-title">Create Hierarchy</h3>
      <div class="header-actions">
        <i (click)="closeCreateHierarchyModal()" class="fa fa-times"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="center-block">
        <form #createHierarchyForm="ngForm">
          <div class="form-group">
            <label>Source Hierarchy</label>
            <select class="form-control" [(ngModel)]="createSrcHierarchyId" name="createSrcHierarchyId">
              <option [ngValue]="null">None</option>
              @for (h of hierarchiesLeft; track $index) {
<option [ngValue]="h.hierarchy_id">{{ h.hierarchy_name }}</option>
}
            </select>
          </div>

          <div class="form-group">
            <label>Destination Application</label>
            <select class="form-control" [(ngModel)]="createDestAppCode" name="createDestAppCode" (ngModelChange)="onCreateDestinationAppChange()" required>
              <option value=""></option>
              @for (app of appsRight; track $index) {
<option [value]="app.id">{{ app.label }}</option>
}
            </select>
          </div>

          <div class="form-group top-margin">
            <label>Name of the Hierarchy:</label>
            <input name="newHzchName" type="text" class="form-control" [(ngModel)]="createHierarchyName" required />
            @if (createHierarchyForm.submitted && !createHierarchyName) {
<span class="error-message">Hierarchy is required</span>
}
            @if (createHierarchyNameExistsInSource) {
<span class="error-message">Hierarchy name already exists in Application</span>
}
            @if (createHierarchyNameExistsInDestination) {
<span class="error-message">Hierarchy name already exists in Destination Application</span>
}
          </div>

          <div class="form-group top-margin">
            <label>BU Code:</label>
            <input type="text" name="buCode" class="form-control" minlength="3" maxlength="6" pattern="[^\s-]+" [(ngModel)]="buCode" required />
            @if (createHierarchyForm.controls.buCode?.touched && createHierarchyForm.controls.buCode?.invalid) {
<span class="error-message">
              The BU Code should be 3-6 characters and must not contain spaces/hyphen.
            </span>
}
          </div>

          <div class="form-group top-margin">
            <label>BU Description:</label>
            <input type="text" class="form-control" name="buDesc" [(ngModel)]="buDesc" required />
            @if (createHierarchyForm.controls.buDesc?.touched && createHierarchyForm.controls.buDesc?.invalid) {
<span class="error-message">
              The BU Description is required.
            </span>
}
          </div>

          <div class="form-group top-margin">
            <label>Line of Business:</label>
            <select name="buLineOfBusiness" class="form-control" [(ngModel)]="buLineOfBusiness" required>
              <option value="IND">IND</option>
              <option value="FIN">FIN</option>
            </select>
          </div>

          <div class="form-group top-margin">
            <label>Detail BSLA?</label>
            <select name="buDetailBsla" class="form-control" [(ngModel)]="buDetailBsla">
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-warning" (click)="closeCreateHierarchyModal()">Cancel</button>
      <button
        class="btn btn-primary"
        (click)="submitCreateHierarchy()"
        [disabled]="createLoading || !createDestAppCode || !createHierarchyName || createHierarchyNameExistsInSource || createHierarchyNameExistsInDestination">
        Create @if (createLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
    </div>
  </div>
</div>
}

<!-- ======================================================================= -->
<!-- Create / Edit Business Unit Modal                                       -->
<!-- ======================================================================= -->
@if (showBusinessUnitModal) {
<div class="modal-overlay">
  <div class="modal-dialog-content admin-modal">
    <div class="modal-header">
      <h3 class="modal-title">{{ buEditMode ? 'Edit Business Unit' : 'Create Business Unit' }}</h3>
      <div class="header-actions">
        <i (click)="closeBusinessUnitModal()" class="fa fa-times"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>BU Code</label>
        <input class="form-control" [(ngModel)]="buCode" />
      </div>
      <div class="form-group">
        <label>BU Description</label>
        <input class="form-control" [(ngModel)]="buDesc" />
      </div>
      <div class="form-group">
        <label>Line of Business</label>
        <select class="form-control" [(ngModel)]="buLineOfBusiness">
          <option value=""></option>
          <option value="IND">IND</option>
          <option value="FIN">FIN</option>
        </select>
      </div>
      <div class="form-group">
        <label>Detail BSLA Indicator</label>
        <select class="form-control" [(ngModel)]="buDetailBsla">
          <option value=""></option>
          <option value="Y">Yes</option>
          <option value="N">No</option>
        </select>
      </div>
      <div class="form-group">
        <label>Estimated Data Collection Level</label>
        <input class="form-control" [(ngModel)]="buEstDataCollection" />
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-warning" (click)="closeBusinessUnitModal()">Cancel</button>
      <button class="btn btn-primary" (click)="submitCreateBusinessUnit()" [disabled]="buLoading">
        {{ buEditMode ? 'Save' : 'Create' }} @if (buLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
    </div>
  </div>
</div>
}

<!-- ======================================================================= -->
<!-- Create Hierarchy from Excel Modal                                       -->
<!-- ======================================================================= -->
@if (showCreateHierarchyExcelModal) {
<div class="modal-overlay">
  <div class="modal-dialog-content create-hierarchy-excel-modal admin-modal">
    <div class="modal-header">
      <h3 class="modal-title">Create Hierarchy (Excel)</h3>
      <div class="header-actions">
        <i (click)="closeCreateHierarchyExcelModal()" class="fa fa-times"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Destination Application</label>
        <select class="form-control" [(ngModel)]="excelDestAppCode" (ngModelChange)="onExcelDestinationAppChange()">
          <option value=""></option>
          @for (app of appsRight; track $index) {
<option [value]="app.id">{{ app.label }}</option>
}
        </select>
      </div>
      <div class="form-group">
        <label>Name of the Hierarchy</label>
        <input class="form-control" [(ngModel)]="excelHierarchyName" />
        @if (excelHierarchyNameExists) {
<span class="text-danger">Hierarchy name already exists in Destination Application</span>
}
      </div>
      <div class="form-group excel-header-row">
        <label>Include Header</label>
        <input type="checkbox" [(ngModel)]="excelIncludeHeader" />
      </div>
      <div class="form-group excel-input">
        <input id="fake-excel-input" class="form-control" [value]="excelSelectedFileName" disabled />
        <label class="custom-file-upload">
          <input
            id="excel-input"
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            (change)="onExcelFileChange($event)" />
          Upload
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-warning" (click)="closeCreateHierarchyExcelModal()">Cancel</button>
      <button
        class="btn btn-primary"
        (click)="submitCreateHierarchyWithExcel()"
        [disabled]="!excelDestAppCode || !excelHierarchyName || !excelSelectedFileName || excelHierarchyNameExists || excelLoading">
        Import @if (excelLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
    </div>
  </div>
</div>
}
